function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import MarkdownIt from 'markdown-it';
import { MarkdownParser } from 'prosemirror-markdown';
import { baseSchemaToMdMapping, baseNodesMdToPmMapping, baseMarksMdToPmMapping, filterMdToPmSchemaMapping } from './parser';
export var articleSchemaToMdMapping = {
  nodes: _objectSpread(_objectSpread({}, baseSchemaToMdMapping.nodes), {}, {
    rule: 'hr',
    heading: ['heading'],
    image: 'image'
  }),
  marks: _objectSpread({}, baseSchemaToMdMapping.marks)
};
export var articleMdToPmMapping = _objectSpread(_objectSpread(_objectSpread({}, baseNodesMdToPmMapping), baseMarksMdToPmMapping), {}, {
  hr: {
    node: 'rule'
  },
  heading: {
    block: 'heading',
    attrs: function attrs(tok) {
      return {
        level: +tok.tag.slice(1)
      };
    }
  },
  image: {
    node: 'image',
    getAttrs: function getAttrs(tok) {
      return {
        src: tok.attrGet('src'),
        title: tok.attrGet('title') || null,
        alt: tok.children[0] && tok.children[0].content || null
      };
    }
  },
  mention: {
    node: 'mention',
    getAttrs: function getAttrs(_ref) {
      var mention = _ref.mention;
      var userId = mention.userId,
          userFullName = mention.userFullName;
      return {
        userId: userId,
        userFullName: userFullName
      };
    }
  }
});
var md = MarkdownIt('zero', {
  html: false,
  linkify: true
});
md.enable([// Process html entity - &#123;, &#xAF;, &quot;, ...
'entity', // Process escaped chars and hardbreaks
'escape']);
export var ArticleMarkdownTransformer = /*#__PURE__*/function () {
  function ArticleMarkdownTransformer(schema) {
    var tokenizer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : md;

    _classCallCheck(this, ArticleMarkdownTransformer);

    // Enable markdown plugins based on schema
    ['nodes', 'marks'].forEach(function (key) {
      for (var idx in articleSchemaToMdMapping[key]) {
        if (schema[key][idx]) {
          tokenizer.enable(articleSchemaToMdMapping[key][idx]);
        }
      }
    });
    this.markdownParser = new MarkdownParser(schema, tokenizer, filterMdToPmSchemaMapping(schema, articleMdToPmMapping));
  }

  _createClass(ArticleMarkdownTransformer, [{
    key: "encode",
    value: function encode(_node) {
      throw new Error('This is not implemented yet');
    }
  }, {
    key: "parse",
    value: function parse(content) {
      return this.markdownParser.parse(content);
    }
  }]);

  return ArticleMarkdownTransformer;
}();